export const interests = [
	"Art",
	"Cooking",
	"Music",
	"Other",
	"Reading",
	"Sports",
	"Tech",
	"Travel"
];

export const advice = [
	"Duke's major departments",
	"Graduate programs or professional schools",
	"Duke extracurriculars",
	"Life",
	"Career",
	"Cool ideas"
];